import React from "react";

export const PriorityExpedite = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5878 6.9809L20.0878 10.9809L20.1982 11.0463C20.724 11.3994 20.9069 12.1003 20.6025 12.6713C20.2979 13.2425 19.6136 13.481 19.0273 13.2407L18.912 13.186L11.9999 9.49945L5.08783 13.186C4.47871 13.5108 3.72225 13.2804 3.3974 12.6713C3.0726 12.0622 3.30294 11.3058 3.91205 10.9809L11.412 6.9809L11.9999 6.66644L12.5878 6.9809Z"
        fill="#0075FF"
        fill-opacity="0.75"
      />
      <path
        d="M12.5878 11.9809L20.0878 15.9809L20.1982 16.0463C20.724 16.3994 20.9069 17.1003 20.6025 17.6713C20.2979 18.2425 19.6136 18.481 19.0273 18.2407L18.912 18.186L11.9999 14.4995L5.08783 18.186C4.47871 18.5108 3.72225 18.2804 3.3974 17.6713C3.0726 17.0622 3.30294 16.3058 3.91205 15.9809L11.412 11.9809L11.9999 11.6664L12.5878 11.9809Z"
        fill="#0075FF"
        fill-opacity="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0878 5.9809L12.5878 1.9809L11.9999 1.66644L11.412 1.9809L3.91205 5.9809C3.30294 6.30575 3.0726 7.06221 3.3974 7.67133C3.72225 8.28043 4.47871 8.51077 5.08783 8.18597L11.9999 4.49945L18.912 8.18597L19.0273 8.24066C19.6136 8.48097 20.2979 8.24247 20.6025 7.67133C20.9069 7.10035 20.724 6.39945 20.1982 6.04633L20.0878 5.9809Z"
        fill="#0075FF"
      />
      <path
        d="M12.5878 16.9809L20.0878 20.9809L20.1982 21.0463C20.724 21.3994 20.9069 22.1003 20.6025 22.6713C20.2979 23.2425 19.6136 23.481 19.0273 23.2407L18.912 23.186L11.9999 19.4995L5.08783 23.186C4.47871 23.5108 3.72225 23.2804 3.3974 22.6713C3.0726 22.0622 3.30294 21.3058 3.91205 20.9809L11.412 16.9809L11.9999 16.6664L12.5878 16.9809Z"
        fill="#0075FF"
        fill-opacity="0.25"
      />
    </svg>
  );
};

export const PriorityHigh = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5878 9.4809L20.0878 13.4809L20.1982 13.5463C20.724 13.8994 20.9069 14.6003 20.6025 15.1713C20.2979 15.7425 19.6136 15.981 19.0273 15.7407L18.912 15.686L11.9999 11.9995L5.08783 15.686C4.47871 16.0108 3.72225 15.7804 3.3974 15.1713C3.0726 14.5622 3.30294 13.8058 3.91205 13.4809L11.412 9.4809L11.9999 9.16644L12.5878 9.4809Z"
        fill="#EF3737"
        fill-opacity="0.66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5878 4.4809L20.0878 8.4809L20.1982 8.54633C20.724 8.89945 20.9069 9.60035 20.6025 10.1713C20.2979 10.7425 19.6136 10.981 19.0273 10.7407L18.912 10.686L11.9999 6.99945L5.08783 10.686C4.47871 11.0108 3.72225 10.7804 3.3974 10.1713C3.0726 9.56221 3.30294 8.80575 3.91205 8.4809L11.412 4.4809L11.9999 4.16644L12.5878 4.4809Z"
        fill="#EF3737"
      />
      <path
        d="M12.5878 14.4809L20.0878 18.4809L20.1982 18.5463C20.724 18.8994 20.9069 19.6003 20.6025 20.1713C20.2979 20.7425 19.6136 20.981 19.0273 20.7407L18.912 20.686L11.9999 16.9995L5.08783 20.686C4.47871 21.0108 3.72225 20.7804 3.3974 20.1713C3.0726 19.5622 3.30294 18.8058 3.91205 18.4809L11.412 14.4809L11.9999 14.1664L12.5878 14.4809Z"
        fill="#EF3737"
        fill-opacity="0.33"
      />
    </svg>
  );
};

export const PriorityMedium = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0878 10.9809L12.5878 6.9809L11.9999 6.66644L11.412 6.9809L3.91205 10.9809C3.30294 11.3058 3.0726 12.0622 3.3974 12.6713C3.72225 13.2804 4.47871 13.5108 5.08783 13.186L11.9999 9.49945L18.912 13.186L19.0273 13.2407C19.6136 13.481 20.2979 13.2425 20.6025 12.6713C20.9069 12.1003 20.724 11.3994 20.1982 11.0463L20.0878 10.9809Z"
        fill="#FFB700"
      />
      <path
        d="M12.5878 11.9809L20.0878 15.9809L20.1982 16.0463C20.724 16.3994 20.9069 17.1003 20.6025 17.6713C20.2979 18.2425 19.6136 18.481 19.0273 18.2407L18.912 18.186L11.9999 14.4995L5.08783 18.186C4.47871 18.5108 3.72225 18.2804 3.3974 17.6713C3.0726 17.0622 3.30294 16.3058 3.91205 15.9809L11.412 11.9809L11.9999 11.6664L12.5878 11.9809Z"
        fill="#FFB700"
        fill-opacity="0.5"
      />
    </svg>
  );
};
export const PriorityLow = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5878 9.4809L20.0878 13.4809L20.1982 13.5463C20.724 13.8994 20.9069 14.6003 20.6025 15.1713C20.2979 15.7425 19.6136 15.981 19.0273 15.7407L18.912 15.686L11.9999 11.9995L5.08783 15.686C4.47871 16.0108 3.72225 15.7804 3.3974 15.1713C3.0726 14.5622 3.30294 13.8058 3.91205 13.4809L11.412 9.4809L11.9999 9.16644L12.5878 9.4809Z"
        fill="#00C12D"
      />
    </svg>
  );
};
